import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { productsApi, cartApi } from '../utils/api';
import { getImageUrl } from '../config/imageConfig';
import CarouselBanner from './common/CarouselBanner';
import './Shop.css';

function Shop() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [hotProducts, setHotProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [cartLoading, setCartLoading] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  
  // 图片资源 - 使用全局配置处理URL
  const shopHeroImg = getImageUrl('https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2342&q=80');
  const product1Img = getImageUrl('https://images.unsplash.com/photo-1590422749897-47726d1b0b5d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const product2Img = getImageUrl('https://images.unsplash.com/photo-1554577621-1a3def0b499c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const product3Img = getImageUrl('https://images.unsplash.com/photo-1559563362-c667ba5f5480?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const product4Img = getImageUrl('https://images.unsplash.com/photo-1531587426902-6cc3fbf7b4f0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const product5Img = getImageUrl('https://images.unsplash.com/photo-1551893098-01f1e01611c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const product6Img = getImageUrl('https://images.unsplash.com/photo-1596470663180-7873fd8956a8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const product7Img = getImageUrl('https://images.unsplash.com/photo-1603912814246-990391a9446d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const product8Img = getImageUrl('https://images.unsplash.com/photo-1617286947243-8e4f570b329b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');

  // 获取商品数据
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // 获取商品分类
        try {
          const categoriesResponse = await productsApi.getProductCategories();
          setCategories(categoriesResponse.data || []);
        } catch (err) {
          console.log('使用默认分类数据');
          setCategories([
            { id: 'herbs', name: '草本花茶' },
            { id: 'plants', name: '盆栽植物' },
            { id: 'seeds', name: '种子种苗' },
            { id: 'garden', name: '园艺用品' },
            { id: 'crafts', name: '手工艺品' },
            { id: 'books', name: '图书资料' }
          ]);
        }
        
        // 获取精选商品（推荐商品）
        try {
          const featuredResponse = await productsApi.getHomepageProducts({ 
            isFeatured: true, 
            page: 1, 
            size: 6 
          });
          setFeaturedProducts(featuredResponse.data?.records || []);
        } catch (err) {
          console.log('使用默认精选商品数据');
          setFeaturedProducts(defaultProducts.filter(p => p.isNew || p.isBestseller).slice(0, 6));
        }
        
        // 获取热销商品（根据销量排序）
        try {
          const hotResponse = await productsApi.getHomepageProducts({ 
            page: 1, 
            size: 8 
          });
          // 过滤出热销商品（isHot=1或销量高的商品）
          const hotItems = hotResponse.data?.records?.filter(product => 
            product.isHot === 1 || product.salesCount > 50
          ) || [];
          setHotProducts(hotItems.slice(0, 8));
        } catch (err) {
          console.log('使用默认热销商品数据');
          setHotProducts(defaultProducts.filter(p => p.isBestseller).slice(0, 8));
        }
        
        // 获取商品目录
        await fetchProducts();
        
      } catch (err) {
        setError('获取商品数据失败，请稍后重试');
        console.error('Error fetching products data:', err);
        // 使用默认数据作为后备
        setFeaturedProducts(defaultProducts.filter(p => p.isFeatured).slice(0, 6));
        setHotProducts(defaultProducts.filter(p => p.isBestseller).slice(0, 8));
        setProducts(defaultProducts);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  
  // 获取商品目录数据
  const fetchProducts = async (page = 1) => {
    try {
      const params = {
        page,
        size: 12
      };
      
      if (selectedCategory) {
        params.categoryId = selectedCategory;
      }
      
      const response = await productsApi.getHomepageProducts(params);
      const data = response.data || {};
      
      setProducts(data.records || []);
      setCurrentPage(data.current || 1);
      setTotalPages(data.pages || 1);
    } catch (err) {
      console.log('使用默认商品目录数据');
      // 使用默认数据作为后备
      const filtered = selectedCategory 
        ? defaultProducts.filter(p => p.category === selectedCategory)
        : defaultProducts;
      setProducts(filtered);
      setCurrentPage(1);
      setTotalPages(1);
    }
  };
  
  // 当分类改变时重新获取商品
  useEffect(() => {
    if (!loading) {
      fetchProducts(1);
    }
  }, [selectedCategory]); // eslint-disable-line react-hooks/exhaustive-deps
  
  // 默认商品数据（当API数据不可用时）
  const defaultProducts = [
    {
      id: 1,
      name: '四季养生茶礼盒',
      category: 'herbs',
      price: 128,
      image: product1Img,
      description: '精选四种应季药食同源植物，根据春夏秋冬四季特点配制的养生茶饮。礼盒内含四种茶饮，每种30g，附详细冲泡说明。',
      features: [
        '纯天然植物配方，无添加',
        '传统中医理论指导下的科学配比',
        '精美包装，适合送礼',
        '保质期12个月'
      ],
      isNew: true,
      isBestseller: false,
      stock: 35
    },
    {
      id: 2,
      name: '药用植物盆栽套装',
      category: 'plants',
      price: 168,
      image: product2Img,
      description: '包含5种常见药用植物的盆栽套装，包括薄荷、迷迭香、金银花、芦荟和薰衣草。附详细的养护指南和药用价值说明。',
      features: [
        '精选健康植株，保证成活率',
        '环保材质花盆',
        '配套营养土和基础肥料',
        '详细的养护手册'
      ],
      isNew: false,
      isBestseller: true,
      stock: 20
    },
    {
      id: 3,
      name: '手工香囊',
      category: 'crafts',
      price: 58,
      image: product3Img,
      description: '采用传统工艺制作的香囊，内含中药材和天然香料。有助于提神醒脑、驱虫防蚊、净化空气。多种款式可选。',
      features: [
        '纯手工制作，每件独特',
        '传统中药配方填充',
        '天然棉麻材质外壳',
        '香气持久，可用3-6个月'
      ],
      isNew: false,
      isBestseller: true,
      stock: 42
    },
    {
      id: 4,
      name: '中药材种子礼盒',
      category: 'seeds',
      price: 88,
      image: product4Img,
      description: '精选10种常见药用植物种子，适合家庭种植。包括白芷、金银花、薄荷、紫苏、益母草等。配有详细种植指南。',
      features: [
        '优质种源，发芽率高',
        '适合阳台、花园种植',
        '环保包装，送礼佳选',
        '附专业种植养护手册'
      ],
      isNew: true,
      isBestseller: false,
      stock: 50
    },
    {
      id: 5,
      name: '艾草驱蚊香薰',
      category: 'herbs',
      price: 35,
      image: product5Img,
      description: '以传统中药艾草为主要成分制作的天然香薰，具有驱蚊、净化空气的功效。无化学添加，安全环保。',
      features: [
        '天然艾草提取，无化学成分',
        '温和释香，驱蚊效果好',
        '可用于室内各区域',
        '燃烧时间约2小时/支'
      ],
      isNew: false,
      isBestseller: false,
      stock: 65
    },
    {
      id: 6,
      name: '手工草药皂',
      category: 'crafts',
      price: 42,
      image: product6Img,
      description: '采用天然植物油脂和药用植物精华制作的手工皂，温和清洁肌肤，多种功效可选，如舒缓、保湿、净化等。',
      features: [
        '冷制手工皂，保留植物精华',
        '无添加剂、防腐剂',
        '温和清洁，适合敏感肌肤',
        '精美包装，环保可降解'
      ],
      isNew: false,
      isBestseller: false,
      stock: 40
    },
    {
      id: 7,
      name: '庐山植物图鉴',
      category: 'books',
      price: 98,
      image: product7Img,
      description: '全面介绍庐山地区常见植物的图鉴，包含500多种植物的彩色图片、详细描述和分布信息。植物爱好者的必备参考书。',
      features: [
        '高清植物照片和精细插图',
        '专业植物学家编写',
        '包含详细的植物分类和识别要点',
        '附庐山植物分布地图'
      ],
      isNew: false,
      isBestseller: true,
      stock: 25
    },
    {
      id: 8,
      name: '家庭药用植物种植套装',
      category: 'garden',
      price: 228,
      image: product8Img,
      description: '一套完整的药用植物家庭种植工具和材料，包含园艺工具、有机种植土、自动浇水器、种子和详细指南。',
      features: [
        '高品质园艺工具套装',
        '智能浇水提醒功能',
        '有机种植土和天然肥料',
        '全面的种植指南和养护建议'
      ],
      isNew: true,
      isBestseller: false,
      stock: 15
    }
  ];

  // 处理商品数据，兼容API返回的字段格式
  const processProduct = (product) => {
    return {
      ...product,
      image: getImageUrl(product.imageUrl || product.image),
      category: product.categoryId || product.category,
      isNew: product.isNew === 1 || product.tags?.includes('新品'),
      isBestseller: product.isHot === 1 || product.tags?.includes('畅销'),
      stock: product.stock || 0
    };
  };
  
  // 处理分类变更
  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId);
    setCurrentPage(1);
  };
  
  // 处理分页
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchProducts(page);
  };
  
  // 添加到购物车
  const handleAddToCart = async (productId) => {
    try {
      setCartLoading(prev => ({ ...prev, [productId]: true }));
      await cartApi.addToCart(productId, 1);
      alert('商品已添加到购物车');
    } catch (err) {
      console.error('Error adding to cart:', err);
      alert('添加到购物车失败，请稍后重试');
    } finally {
      setCartLoading(prev => ({ ...prev, [productId]: false }));
    }
  };
  
  // 查看商品详情
  const handleViewDetails = (productId) => {
    navigate(`/products/${productId}`);
  };

  return (
    <div>
      {/* Hero Section - 使用轮播图组件 */}
      <CarouselBanner 
        categoryNameEn="YYDP"
        defaultImage={shopHeroImg}
        defaultTitle="杏林花园商店"
        defaultSubtitle="精选药用植物、花草茶、手工艺品和园艺用品，带回家中的自然馈赠"
        className="hero-section"
      />
      
      <div className="container">
        <section className="featured-section">
          <h2 className="section-title">精选商品</h2>
          {loading ? (
            <div className="loading-message">加载中...</div>
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : (
            <div className="products-row">
              {featuredProducts.map(product => {
                const processedProduct = processProduct(product);
                return (
                  <div key={product.id} className="product-card featured">
                    <div className="product-image">
                      <img 
                        src={processedProduct.image} 
                        alt={product.name}
                        onError={(e) => {
                          e.target.src = product1Img;
                        }}
                      />
                      {processedProduct.isNew && <span className="product-badge new">新品</span>}
                      {processedProduct.isBestseller && <span className="product-badge bestseller">畅销</span>}
                      {product.isFeatured === 1 && <span className="product-badge featured">精选</span>}
                    </div>
                    <div className="product-content">
                      <h3 className="product-name">{product.name}</h3>
                      <div className="product-price-container">
                        <span className="product-price">¥{product.price}</span>
                        {product.originalPrice && product.originalPrice > product.price && (
                          <span className="product-original-price">¥{product.originalPrice}</span>
                        )}
                      </div>
                      <p className="product-description">
                        {product.description?.substring(0, 60)}...
                      </p>
                      <div className="product-actions">
                        <button 
                          className="btn btn-primary"
                          onClick={() => handleViewDetails(product.id)}
                        >
                          查看详情
                        </button>
                        <button 
                           className="btn btn-icon"
                           onClick={() => handleAddToCart(product.id)}
                           disabled={cartLoading[product.id]}
                         >
                           {cartLoading[product.id] ? '...' : '🛒'}
                         </button>
                       </div>
                     </div>
                   </div>
                 );
               })}
             </div>
           )}
         </section>
        
        <section className="hot-products-section">
          <h2 className="section-title">热销商品</h2>
          {loading ? (
            <div className="loading-message">加载中...</div>
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : (
            <div className="products-row">
              {hotProducts.map(product => {
                const processedProduct = processProduct(product);
                return (
                  <div key={product.id} className="product-card">
                    <div className="product-image">
                      <img 
                        src={processedProduct.image} 
                        alt={product.name}
                        onError={(e) => {
                          e.target.src = product2Img;
                        }}
                      />
                      {processedProduct.isNew && <span className="product-badge new">新品</span>}
                      {processedProduct.isBestseller && <span className="product-badge bestseller">畅销</span>}
                      {product.isHot === 1 && <span className="product-badge hot">热销</span>}
                    </div>
                    <div className="product-content">
                      <h3 className="product-name">{product.name}</h3>
                      <div className="product-price-container">
                        <span className="product-price">¥{product.price}</span>
                        {product.originalPrice && product.originalPrice > product.price && (
                          <span className="product-original-price">¥{product.originalPrice}</span>
                        )}
                      </div>
                      {product.salesCount && (
                        <p className="product-sales">已售 {product.salesCount} 件</p>
                      )}
                      <div className="product-actions">
                        <button 
                          className="btn btn-primary"
                          onClick={() => handleViewDetails(product.id)}
                        >
                          查看详情
                        </button>
                        <button 
                          className="btn btn-icon"
                          onClick={() => handleAddToCart(product.id)}
                          disabled={cartLoading[product.id]}
                        >
                          {cartLoading[product.id] ? '...' : '🛒'}
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </section>
        

        
        <section className="product-catalog">
          <h2 className="section-title">商品目录</h2>
          
          <div className="catalog-filters">
            <button 
              className={`filter-btn ${selectedCategory === null ? 'active' : ''}`}
              onClick={() => handleCategoryChange(null)}
            >
              全部商品
            </button>
            {categories.map(category => (
              <button 
                key={category.id}
                className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => handleCategoryChange(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
          
          {loading ? (
            <div className="loading-message">加载中...</div>
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : (
            <>
              <div className="products-grid">
                {products.map(product => {
                  const processedProduct = processProduct(product);
                  return (
                    <div key={product.id} className="product-card">
                      <div className="product-image">
                        <img 
                          src={processedProduct.image} 
                          alt={product.name}
                          onError={(e) => {
                            e.target.src = product1Img;
                          }}
                        />
                        {processedProduct.isNew && <span className="product-badge new">新品</span>}
                        {processedProduct.isBestseller && <span className="product-badge bestseller">畅销</span>}
                      </div>
                      <div className="product-content">
                        <h3 className="product-name">{product.name}</h3>
                        <div className="product-price-container">
                          <span className="product-price">¥{product.price}</span>
                          {product.originalPrice && product.originalPrice > product.price && (
                            <span className="product-original-price">¥{product.originalPrice}</span>
                          )}
                        </div>
                        <p className="product-description">{product.description?.substring(0, 80)}...</p>
                        <div className="product-stock">
                          <span className={`stock-indicator ${processedProduct.stock < 20 ? 'low' : ''}`}></span>
                          <span className="stock-text">
                            {processedProduct.stock < 10 ? '库存紧张' : `库存: ${processedProduct.stock}`}
                          </span>
                        </div>
                        <div className="product-actions">
                          <button 
                            className="btn btn-primary"
                            onClick={() => handleViewDetails(product.id)}
                          >
                            查看详情
                          </button>
                          <button 
                            className="btn btn-icon"
                            onClick={() => handleAddToCart(product.id)}
                            disabled={cartLoading[product.id]}
                          >
                            {cartLoading[product.id] ? '...' : '🛒'}
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              
              {totalPages > 1 && (
                <div className="pagination">
                  <button 
                    className="btn btn-secondary"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    上一页
                  </button>
                  <span className="page-info">
                    第 {currentPage} 页，共 {totalPages} 页
                  </span>
                  <button 
                    className="btn btn-secondary"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    下一页
                  </button>
                </div>
              )}
            </>
          )}
        </section>
      </div>
    </div>
  );
}

export default Shop;